import { motion } from 'framer-motion'
import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { humanReadableTimePassed } from '../../Helper/Algos'
import { BASE_URL_API } from '../../References/url'
import AuthContext from '../../Store/auth-context'
import styles from './AllRedemptionOrder.module.css'

const AllRedemptionOrder = () => {

    const [allOrders, setAllOrders] = useState([])
    const authCtx = useContext(AuthContext)
    const [filteredData, setFilteredData] = useState([])
    const [searchKey, setSearchKey] = useState('')

    const getAllOrder = async () => {
        const getAllOrderResponse = await fetch(BASE_URL_API + "/getAllRedemptionOrders",
            {
                method: 'POST',
                body: JSON.stringify({
                    token: authCtx.token,
                    clientIdentifier: authCtx.clientIdentifier
                })
            });

        if (!getAllOrderResponse.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const getAllOrderRespo = await getAllOrderResponse.json()
            if (getAllOrderRespo.status === "success") {
                setAllOrders(getAllOrderRespo?.response)
                setFilteredData(getAllOrderRespo?.response)
            } else {
                if (getAllOrderRespo.message === 'token Expired, please login again!') {
                    authCtx.logout()
                } else {
                    setAllOrders([])
                }
            }
            console.log(getAllOrderRespo)
        }
    }

    useEffect(() => {
        getAllOrder()
    }, [])




    const filterData = (data, searchKey) => {
        setFilteredData(data.filter(item =>
            Object.values(item).some(value =>
                value?.toString().toLowerCase().includes(searchKey.toLowerCase())
            )
        ))
    }

    useEffect(() => {
        filterData(allOrders, searchKey)
    }, [searchKey])


    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: {
                delay: i * 0.05,
                duration: 0.3,
                type: 'spring',
            },
        }),
    };

    return (
        <div>
            <div className={styles.mainWrapper}>
                <div>
                    <div className={styles.topWrapper}>
                        <div className={styles.statsTxt}>
                            All Orders
                        </div>
                        <div className={styles.searchInput}>
                            <input placeholder="Search for anything..." value={searchKey} onChange={(e) => setSearchKey(e.target.value)} />
                        </div>
                    </div>

                    <div className={styles.tableWrapper}>
                        <div className={styles.rowsWrapper}>
                            {filteredData?.map((item, index) => (
                                <motion.div className={styles.eachRowWrapper} key={index}
                                    variants={itemVariants}
                                    initial="hidden"
                                    animate="visible"
                                    custom={index}
                                >
                                    <div className={styles.firstRowWrapper}>
                                        <div className={styles.leftCol}>
                                            <div className={styles.thumbnailWrapper}>
                                                {item?.items?.slice(0, 3)?.map((itemItems, indexItems) => (
                                                    <div
                                                        className={styles.thumbnail}
                                                        key={indexItems}
                                                        style={{
                                                            left: `${indexItems * 10}px`,
                                                            top: `${indexItems * 10}px`,
                                                            zIndex: item?.items?.length - indexItems
                                                        }}
                                                    >
                                                        <img
                                                            src={
                                                                itemItems?.productThumbnail ||
                                                                "https://t4.ftcdn.net/jpg/12/00/79/01/360_F_1200790111_37LoouDliNEWTX3ivRhB1IqJFvjl4PqR.jpg"
                                                            }
                                                        />
                                                    </div>
                                                ))}

                                            </div>
                                        </div>
                                        <div className={styles.centerCol}>
                                            <div className={styles.sn}>
                                                # {item?.orderIdentifier}
                                            </div>
                                            <div className={styles.receiverDetails}>
                                                <div className={styles.fullname}>
                                                    {item?.receiverPerson}, {item?.receiverPhone}
                                                </div>
                                                <div className={styles.address}>
                                                    <div className={styles.fullAddress}>
                                                        {item?.deliveryAddress}
                                                    </div>
                                                </div>
                                                <div className={styles.address}>
                                                    {item?.items?.length} item(s)!
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className={styles.points}>
                                                {item?.isPointsBasedTransaction === "0" ?
                                                    <span>
                                                        ₹{item?.totalAmount}
                                                    </span>
                                                    :
                                                    <div>
                                                        <div className={styles.totalPoints}>
                                                            {parseInt(item?.totalPoints)}
                                                        </div>
                                                        <div className={styles.puTxt}>Points used</div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className={styles.rightCol}>
                                            <div className={styles.currentStatus}>
                                                {item?.currentStatus}
                                            </div>
                                            <div className={styles.dateTime}>
                                                {humanReadableTimePassed(item?.placedOn)}
                                            </div>
                                            <div className={styles.dateTime}>
                                                <div className={styles.placedOn}>
                                                    {item?.placedOn}
                                                </div>
                                            </div>
                                            <div className={styles.time}>
                                                <Link to={`/redemption-order/${item?.orderIdentifier}`}>View Details</Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={styles.secondRowWrapper}>
                                        <div>

                                        </div>
                                    </div>

                                </motion.div>
                            ))}
                        </div>
                    </div>


                </div>
            </div>

        </div>
    )
}

export default AllRedemptionOrder